import { c as _c } from "react/compiler-runtime";
import { styled } from '@classify/react-core-components/styles';
import Typography from '@classify/react-core-components/Typography';
import { palette } from '@classify/react-core-components/Theme';
const PREFIX = 'MarketingHeadline';
const classes = {
  textContainer: `${PREFIX}-textContainer`
};
const StyledTypography = styled(Typography)(({
  theme: {
    spacing
  }
}) => ({
  [`& .${classes.textContainer}`]: {
    display: 'inline',
    padding: `${spacing(0.25)} 0 ${spacing(0.5)} 0`,
    boxDecorationBreak: 'clone'
  }
}));
export const MarketingHeadline = t0 => {
  const $ = _c(22);
  let otherProps;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== t0) {
    ({
      backgroundColor: t1,
      children: t2,
      classes: t3,
      color: t4,
      variant: t5,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = otherProps;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    otherProps = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  const backgroundColor = t1 === undefined ? palette.brand.onContrasted : t1;
  const children = t2 === undefined ? null : t2;
  let t6;
  if ($[7] !== t3) {
    t6 = t3 === undefined ? {} : t3;
    $[7] = t3;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const customClasses = t6;
  const color = t4 === undefined ? palette.text.onContrasted : t4;
  const variant = t5 === undefined ? "h1" : t5;
  const t7 = `16px 0 0 ${backgroundColor}, -16px 0 0 ${backgroundColor}`;
  let t8;
  if ($[9] !== backgroundColor || $[10] !== color || $[11] !== t7) {
    t8 = {
      backgroundColor,
      color,
      boxShadow: t7
    };
    $[9] = backgroundColor;
    $[10] = color;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const style = t8;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      marginLeft: 2
    };
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== children || $[15] !== style) {
    t10 = <span className={classes.textContainer} style={style}>{children}</span>;
    $[14] = children;
    $[15] = style;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== customClasses.root || $[18] !== otherProps || $[19] !== t10 || $[20] !== variant) {
    t11 = <StyledTypography className={customClasses.root} variant={variant} {...otherProps} sx={t9}>{t10}</StyledTypography>;
    $[17] = customClasses.root;
    $[18] = otherProps;
    $[19] = t10;
    $[20] = variant;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
};
export default MarketingHeadline;